export class DetalleCisterna {
  codigo: string;
  volumen: number;
  volumen15: number;
  estado: EstadoCisterna;
}

export enum EstadoCisterna {
  PENDIENTE = 0,
  RECIBIDO = 1,
  RECHAZADO = 2,
}